// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"App_textCenter__pRKAo"};